import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { filter, tap } from 'rxjs';
import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';
import { DataService } from 'src/app/services/data.service';
import { ToastService } from 'src/app/services/toast.service';
import { environment } from 'src/environments/environment';

interface Item {
  title: string;
  id: number;
  below?: Item[];
}

interface FlattenedItem {
  id: number;
  order: number;
  parentId: number | null;
}

@Component({
  selector: 'app-drag-drop',
  templateUrl: './drag-drop.component.html',
  styleUrls: ['./drag-drop.component.scss']
})
export class DragDropComponent implements OnInit {

  @Input() items: Item[] = [];
  @Input() depth: number = 0;
  data!: any;
  loading: any = {
    load: false,
    message: "Caricamento in corso..."
  };
  itemsSource: Item[] = [];
  idList: string[] = [];


  constructor(private dataService: DataService, private cdr: ChangeDetectorRef, public confirmationDialogService: ConfirmationDialogService, private toastService: ToastService) { }

  ngOnInit() {
    if (!this.items || this.items.length === 0) {
      this.loading.load = true;
      this.dataService.getData(environment.endpointDragDropMenu).subscribe(items => {
        this.items = items;
        this.itemsSource = this.cloneItems(this.items);
        this.idList = this.items.map((item: Item) => this.mapItemIdToString(item));
        this.loading.load = false;
      });
    }
  }

  dropItem(event: CdkDragDrop<Item[]>) {
    const movedItem = event.previousContainer.data[event.previousIndex];
    console.log('Moved Item:', movedItem);

    const targetList = event.container.data ?? [];
    console.log('Target List:', targetList);

    const targetItem = targetList[0];
    console.log('Target Item:', targetItem);

    const isSameList = event.container.data === event.previousContainer.data;
    console.log('Is Same List:', isSameList);

    if (isSameList) {
      console.log('Moving item within the same list...', event.container.data, event.previousIndex, event.currentIndex);
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      console.log('Transferring item to a different list...');
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );

    }

  }


  getItemsOrdered(items: Item[], parentId: number | null = null, order: number = 0): FlattenedItem[] {
    let flattened: FlattenedItem[] = [];

    items.forEach((item, index) => {
      flattened.push({
        id: item.id,
        order: index,
        parentId: parentId,
      });

      if (item.below) {
        flattened = flattened.concat(this.getItemsOrdered(item.below, item.id, 0));
      }
    });

    console.log(flattened);
    return flattened;
  }


  isDraggable(below: any, parent: any): boolean {
    return parent.below && parent.below.length > 1 && below.parentId === parent.id;
  }


  mapItemIdToString = (item: Item) => item.id.toString();

  cloneItems(items: Item[]) {
    return JSON.parse(JSON.stringify(items));
  }

  save(): void {
    this.confirmationDialogService.showConfirmModal({
      title: "Salva",
      message: "Sicuro di voler salvare il nuovo ordinamento?",
      confirmButtonLabel: "Conferma",
      cancelButtonLabel: "Annulla",
    }).pipe(
      filter(Boolean),
      tap(() => this.saveDataAndReload())
    ).subscribe();
  }

  saveDataAndReload(): void {
    this.loading.message = "Salvataggio in corso...";
    this.loading.load = true;
    this.dataService.putData({ items: this.getItemsOrdered(this.items) }, "/menuFO/updateOrder")
      .subscribe({
        next: () => this.reloadPage(),
        error: (error) => {
          console.error('Error during saving data:', error);
          this.loading.load = false;
        }
      });
  }

  reloadPage(): void {
    setTimeout(() => this.loading.load = false, 500);
  }

  showToast(message: string): void {
    this.toastService.show({
      template: 'success',
      classname: 'bg-success text-light',
      delay: 3000,
      message
    });
  }

  reset(): void {
    this.items = this.cloneItems(this.itemsSource);
    setTimeout(() => {
      this.cdr.detectChanges();
      this.showToast('Ordinamento resettato con successo!')
    }, 0);
  }

}

